import { Progress as ChakraProgress } from '@chakra-ui/react';
import { forwardRef } from 'react';

export interface ProgressProps extends React.ComponentProps<typeof ChakraProgress.Root> {
  value?: number;
  label?: string;
  showValue?: boolean;
}

export const Progress = forwardRef<HTMLDivElement, ProgressProps>(
  ({ value = 0, label, showValue, ...props }, ref) => {
    return (
      <ChakraProgress.Root ref={ref} value={value} {...props}>
        {(label || showValue) && (
          <ChakraProgress.Label>
            {label} {showValue && `${value}%`}
          </ChakraProgress.Label>
        )}
        <ChakraProgress.Track>
          <ChakraProgress.Range />
        </ChakraProgress.Track>
      </ChakraProgress.Root>
    );
  }
);

Progress.displayName = 'Progress';
